import React, { useEffect, useState } from 'react';
import { Box, Fade, Modal, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { forward, global, input, sip } from "../translate";
import CloseIcon from "@mui/icons-material/Close";
import 'react-quill/dist/quill.snow.css';
import Api from "../Api";
import TiptapEditor from "./TipTapEditor";
import Utils from "../Utils";
import { REACT_APP_API_URL } from '../config';
import { style, } from "../helpers/style";


const langArr = ['en', 'ru', 'hy']
const { REACT_APP_SERVER } = process.env
function AddAndEditNews({ open, setOpen, edit, setList }) {
    const [form, setForm] = useState({
        id: 0,
        title_hy: '',
        title_ru: '',
        title_en: '',
        desc_hy: '',
        desc_ru: '',
        desc_en: '',
        image_hy: [],
        image_ru: [],
        image_en: [],
        status: 1,
        device: 0
    })
    const [lang, setLang] = useState(2)
    const [justSwitchedLang, setJustSwitchedLang] = useState(false)
    let link = REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') ? '/rest' : '')

    useEffect(() => {
        if (edit) {
            (async () => {
                const { data } = await Api.getNewsSingle(edit)
                let {
                    id,
                    title_hy,
                    title_ru,
                    title_en,
                    desc_hy,
                    desc_ru,
                    desc_en,
                    image_hy,
                    image_ru,
                    image_en,
                    status,
                    device
                } = data.list
                setForm({
                    id: id,
                    title_hy: title_hy,
                    title_ru: title_ru,
                    title_en: title_en,
                    desc_hy: Utils.bufferDecoder(desc_hy, 'html'),
                    desc_ru: Utils.bufferDecoder(desc_ru, 'html'),
                    desc_en: Utils.bufferDecoder(desc_en, 'html'),
                    image_hy,
                    image_ru,
                    image_en,
                    status: status,
                    device: device
                })
            })()
        }

    }, [edit])

    const handleAdd = async (ev) => {
        ev.preventDefault()
        const formData = new FormData();

        formData.append("id", form.id); // other text fields
        formData.append("title_hy", form.title_hy);
        formData.append("title_ru", form.title_ru);
        formData.append("title_en", form.title_en);
        formData.append("desc_hy", form.desc_hy);
        formData.append("desc_ru", form.desc_ru);
        formData.append("desc_en", form.desc_en);
        formData.append("status", form.status);
        formData.append("device", form.device);

        // Append images properly
        form.image_hy.forEach(file => {
            formData.append("image_hy", file); // multer handles arrays this way
        });
        form.image_ru.forEach(file => {
            formData.append("image_ru", file);
        });
        form.image_en.forEach(file => {
            formData.append("image_en", file);
        });
        if (edit) {
            const { data } = await Api.updateNews(formData)
            setList(data.list)
        } else {
            const { data } = await Api.createNews(formData)
            setList(data.list)
        }
        console.log(form)
        setOpen(0)
    }
    const handleChange = (name, ev) => {
        setForm((prev) => ({
            ...prev,
            [name]: ev
        }))
    }

    const handleImageChange = (lang, files) => {
        setForm(prev => {
            const key = `image_${lang}`;
            // merge existing + new, but cap at 10
            const merged = [...(prev[key] || []), ...files].slice(0, 10);
            return { ...prev, [key]: merged };
        });
    };

    const handleDelete = async (id, type, removeIndex) => {
        console.log(id, type);
        if (type === "id") {
            await Api.newsDeleteImage(id)
        }

        setForm(prev => {
            console.log(lang);
            
            const key = `image_${langArr[lang]}`;
            const current = prev[key] || [];

            // Keep everything whose index ≠ removeIndex
            const filtered = current.filter((_, i) => i !== removeIndex);

            return { ...prev, [key]: filtered };
        });
    }
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {edit ? 'Փոխել նորություն' : 'Ստեղծել նորություն'}
                        </Typography>
                        <span style={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </span>
                    </div>

                    <form className="news_form" onSubmit={handleAdd}>
                        <label className="d-flex flex-row">
                            <span className="news_title">Ստատուս</span>
                            <input
                                type="checkbox"
                                checked={form.status}
                                onChange={(ev) => handleChange('status', +ev.target.checked)} />
                        </label>
                        <p className="news_title">Ընտրել լեզուն</p>
                        <select
                            value={lang}
                            style={{ width: '50%', border: '1px solid', height: 40, outline: 'none' }}
                            onChange={(ev) => {
                                setLang(+ev.target.value)
                                console.log(form)
                                setJustSwitchedLang(true)
                            }}>
                            <option value="2">Հայերեն</option>
                            <option value="0">Անգլերեն</option>
                            <option value="1">Ռուսերեն</option>
                        </select>
                        <p className="news_title">Ընտրել Սարքը</p>

                        <select
                            value={form.device}
                            style={{ width: '50%', border: '1px solid', height: 40, outline: 'none' }}
                            onChange={(ev) => { handleChange('device', ev.target.value) }}>
                            <option value="0">Համակարգիչ</option>
                            <option value="1">Հեռախոս</option>
                        </select>
                        <label className="d-flex flex-column">
                            <span className="news_title">Վերնագիր</span>
                            <input
                                className="news"
                                value={form['title_' + langArr[lang]] || ''}
                                onChange={(ev) => handleChange('title_' + langArr[lang], ev.target.value)} />
                        </label>
                        <span className="news_title">Նկարագրություն</span>

                        <TiptapEditor
                            value={form['desc_' + langArr[lang]]}
                            onChange={(newVal) => handleChange('desc_' + langArr[lang], newVal)}
                        />
                        <span className="news_title">Նկար</span>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 10 }}>
                            {form[`image_${langArr[lang]}`]?.map((img, idx) => (
                                <figure>
                                    <img
                                        key={idx}
                                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                        src={img instanceof File ? URL.createObjectURL(img) : link + img.url}
                                        alt=""
                                        onLoad={e => {
                                            if (img instanceof File) URL.revokeObjectURL(e.target.src);
                                        }}
                                    />
                                    <figcaption onClick={() => handleDelete(img.id ? img.id : idx, img.id ? "id" : "idx", idx)}><CloseIcon /></figcaption>
                                </figure>
                            ))}
                        </div>
                        <label className="d-flex flex-column">

                            <span className="news_btn">Ընտրել նկարը</span>
                            <input
                                accept="image/*"
                                className="d-none"
                                type="file"
                                multiple                     // ← allows multi‑select
                                onChange={ev =>
                                    handleImageChange(langArr[lang], Array.from(ev.target.files))
                                }
                            />
                        </label>


                        <div className="d-flex justify-content-center" style={{ marginTop: 20 }}>
                            <button onClick={handleAdd} className="addBtnBig">
                                {edit ? global.edit[+localStorage.getItem('atsLang') || 1] : sip.add_btn[+localStorage.getItem('atsLang') || 1]}
                            </button>
                        </div>
                    </form>
                </Box>
            </Fade>
        </Modal>
    )
}

export default AddAndEditNews;